import lighten from 'polished/lib/color/lighten';
import darken from 'polished/lib/color/darken';
var showWarnings = ['production', 'test'].indexOf(process.env.NODE_ENV) === -1;
var colorOffsetDark = 0.07;
var colorOffsetLight = 0.15;
var theme = {
  breakpoints: {
    mobile: '218px',
    mobileWide: '487px',
    tablet: '755px',
    tabletLegacy: '788px',
    tabletWide: '880px',
    desktop: '1024px',
    desktopLegacy: '1056px',
    desktopLarge: '1562px'
  },
  fontSizes: [10, 12, 14, 16, 20, 24, 32, 48, 64, 80],
  space: [0, 4, 8, 16, 32, 64, 128, 256],
  radii: [0, 3, 5],
  measure: {
    narrow: '20em',
    default: '30em',
    wide: '34em'
  },
  lineHeights: {
    solid: 1,
    title: 1.25,
    copy: 1.5
  },
  gradient: {
    skyDew: 'linear-gradient(to right, #76C4E2, #85CBA8)',
    twilightDew: 'linear-gradient(to right, #8176B5, #85CBA8)',
    twilightSky: 'linear-gradient(to right, #8176B5, #76C4E2)',
    twilightSunset: 'linear-gradient(to right, #8176B5, #BA77B1)',
    twilightDawn: 'linear-gradient(to right, #8176B5, #F16975)',
    dawnSunrise: 'linear-gradient(to right, #F16975, #F69259)',
    sunriseLightning: 'linear-gradient(to right, #F69259, #FFDB6F)',
    dewLightning: 'linear-gradient(to right, #85CBA8, #FFDB6F)'
  },
  shadows: ['0 0 20px 0 rgba(136,136,136,0.50)'],
  colors: {
    black: '#000',
    white: '#fff',
    cfOrange: '#F6821F',
    marketing: {
      orange: '#F6821F',
      lightOrange: '#FBAD41',
      red: '#e04e64',
      lightRed: '#e27179',
      green: '#71c492',
      lightGreen: '#9fd3b5',
      cyan: '#2da7cb',
      lightCyan: '#89c4e1',
      purple: '#7d4788',
      lightPurple: '#af7baf',
      blue: '#00517f',
      lightBlue: '#4f8cc8',
      gray: ['#404242', '#707070', '#aaaaaa', '#dddddd', '#f5f5f5']
    },
    vendor: {
      twitter: '#00aced',
      facebook: '#3b5998'
    },
    red: ['#3c0501', '#5a0801', '#780a02', '#970d02', '#b20f03', '#e81403', '#fc574a', '#fe9f97', '#feccc8', '#ffefee'],
    orange: ['#361a02', '#482303', '#592b04', '#763905', '#8d4406', '#c05d08', '#ee730a', '#f8a054', '#fbcda5', '#fef1e6'],
    gold: ['#261c00', '#3e2d00', '#4c3700', '#644900', '#735400', '#a77a00', '#dda100', '#ffce4b', '#ffeab2', '#fff8e4'],
    green: ['#0a2614', '#0e381d', '#104122', '#15562d', '#196535', '#228b49', '#2db35e', '#55d584', '#a8e9c0', '#e3f8eb'],
    cyan: ['#061b20', '#0b333e', '#0d3e4b', '#115061', '#156074', '#1e89a5', '#30b6da', '#73cee6', '#ace2f0', '#e9f7fb'],
    blue: ['#001c43', '#002b67', '#003681', '#0045a6', '#0051c3', '#086fff', '#4693ff', '#82b6ff', '#b9d6ff', '#ecf4ff'],
    indigo: ['#170f58', '#221785', '#2c1ea9', '#3524cd', '#4b3bdc', '#7366e4', '#9d94ec', '#c2bdf3', '#dfdcf9', '#f1f0fc'],
    violet: ['#350b42', '#490f5c', '#5f1477', '#741892', '#8d1eb1', '#b73cdf', '#cf7ee9', '#dfa8f1', '#ebcaf6', '#f7eafb'],
    pink: ['#2d0210', '#4e031c', '#6a0426', '#8d0633', '#af0740', '#e80954', '#f85189', '#fb97b9', '#fdc9db', '#fef1f5'],
    gray: ['#1d1d1d', '#313131', '#3d3d3d', '#4a4a4a', '#595959', '#797979', '#999999', '#b6b6b6', '#d9d9d9', '#f2f2f2'],
    categorical: [// Derived from color-brewer's category20
    '#1f77b4', '#aec7e8', '#ff7f0e', '#ffbb78', '#2ca02c', '#98df8a', '#d62728', '#ff9896', '#9467bd', '#c5b0d5', '#8c564b', '#c49c94', '#e377c2', '#f7b6d2', '#bcbd22', '#dbdb8d', '#17becf', '#9edae5']
  },
  color: {},
  fontSize: '15px',
  boxShadow: '0 0 20px 0 rgba(136,136,136,0.50)',
  inputFontSize: '13px',
  lineHeight: 1.5,
  inputLineHeight: 1.4,
  inputHeight: '2.26667rem',
  em: '1em',
  rem: '1rem',
  fontFamily: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, "Helvetica Neue",  Arial, sans-serif',
  weightLight: 300,
  weightNormal: 400,
  weightSemiBold: 600,
  weightBold: 700,
  fontWeight: 400,
  fontWeightLight: 300,
  borderRadius: '2px',
  fontColor: darken(0.8, '#fff'),
  colorOffsetDark: colorOffsetDark,
  colorGrayLight: darken(0.13, '#fff'),
  // deprecated
  zIndexMax: 1000,
  zIndexModal: 1400
};
var namedColors = {
  grass: {
    value: '#9BCA3E',
    replacement: 'green[6]'
  },
  fern: {
    value: '#85B832',
    replacement: 'green[5]'
  },
  marine: {
    value: '#2F7BBF',
    replacement: 'blue[4]'
  },
  thunder: {
    value: '#286EA4',
    replacement: 'blue[3]'
  },
  apple: {
    value: '#BD2527',
    replacement: 'red[3]'
  },
  cherry: {
    value: '#A61E20',
    replacement: 'red[2]'
  },
  tangerine: {
    value: '#FF7900',
    replacement: 'orange[6]'
  },
  pumpkin: {
    value: '#E66B00',
    replacement: 'orange[4]'
  },
  carrot: {
    value: '#f56500',
    replacement: 'orange[5]'
  },
  moonshine: {
    value: '#F7F7F7',
    replacement: 'gray[9]'
  },
  dust: {
    value: '#ebebeb',
    replacement: 'gray[8]'
  },
  smoke: {
    value: '#e0e0e0',
    replacement: 'gray[7]'
  },
  ash: {
    value: '#CCCCCC',
    replacement: 'gray[6]'
  },
  hail: {
    value: '#BCBEC0',
    replacement: 'gray[5]'
  },
  storm: {
    value: '#808285',
    replacement: 'gray[4]'
  },
  cement: {
    value: '#7D7D7D',
    replacement: 'gray[4]'
  },
  dusk: {
    value: '#4D4D4F',
    replacement: 'gray[3]'
  },
  night: {
    value: '#404041',
    replacement: 'gray[2]'
  },
  charcoal: {
    value: '#333333',
    replacement: 'gray[1]'
  },
  leaf: {
    value: '#cde49e',
    replacement: 'green[7]'
  },
  pine: {
    value: '#f5faeb',
    replacement: 'green[9]'
  },
  blueberry: {
    value: '#97bddf',
    replacement: 'blue[7]'
  },
  ice: {
    value: '#eaf2f8',
    replacement: 'blue[9]'
  },
  water: {
    value: '#cbdeef',
    replacement: 'blue[8]'
  },
  shrimp: {
    value: '#de9293',
    replacement: 'red[6]'
  },
  poppy: {
    value: '#f8e9e9',
    replacement: 'red[9]'
  },
  rain: {
    value: '#408BC9',
    replacement: 'blue[4]'
  },
  sky: {
    value: '#76C4E2',
    replacement: 'blue[6]'
  },
  dew: {
    value: '#85CBA8',
    replacement: 'green[6]'
  },
  deepsea: {
    value: '#1E4E79',
    replacement: 'blue[1]'
  },
  twilight: {
    value: '#8176B5',
    replacement: 'violet[5]'
  },
  sunset: {
    value: '#BA77B1',
    replacement: 'violet[4]'
  },
  dawn: {
    value: '#F16975',
    replacement: 'red[5]'
  },
  sunrise: {
    value: '#F69259',
    replacement: 'orange[7]'
  },
  lightning: {
    value: '#FFDB6F',
    replacement: 'gold[7]'
  }
};
var themeColors = {
  fontColorHeadingCaption: {
    value: '#888',
    replacement: 'colors.gray[4]'
  },
  disabledBackground: {
    value: '#ededed',
    replacement: 'colors.gray[8]'
  },
  bodyBackground: {
    value: '#ebebeb',
    replacement: 'colors.gray[8]'
  },
  bodyAccentColor: {
    value: darken(0.8, '#fff'),
    replacement: 'colors.gray[1]'
  },
  bodyOffsetColor: {
    value: darken(0.53, '#fff'),
    replacement: 'colors.gray[4]'
  },
  colorWhite: {
    value: '#fff',
    replacement: 'colors.white'
  },
  colorBlack: {
    value: '#000',
    replacement: 'colors.black'
  },
  colorInfo: {
    value: '#00a9eb',
    replacement: 'colors.blue[5]'
  },
  colorSuccess: {
    value: '#68970f',
    replacement: 'colors.green[5]'
  },
  colorWarning: {
    value: '#fca520',
    replacement: 'colors.gold[6]'
  },
  colorError: {
    value: '#ff3100',
    replacement: 'colors.red[4]'
  },
  colorMuted: {
    value: darken(0.5125, '#fff'),
    replacement: 'colors.gray[4]'
  },
  colorSmoke: {
    value: '#f2f2f2',
    replacement: 'colors.gray[9]'
  },
  colorBlue: {
    value: '#2f7bbf',
    replacement: 'colors.blue[4]'
  },
  colorBlueLight: {
    value: lighten(colorOffsetLight, '#2f7bbf'),
    replacement: 'colors.blue[5]'
  },
  colorBlueDark: {
    value: darken(colorOffsetDark, '#2f7bbf'),
    replacement: 'colors.blue[3]'
  },
  colorOrange: {
    value: '#ff7900',
    replacement: 'colors.orange[6]'
  },
  colorOrangeLight: {
    value: lighten(colorOffsetLight, '#ff7900'),
    replacement: 'colors.orange[7]'
  },
  colorOrangeDark: {
    value: darken(colorOffsetDark, '#ff7900'),
    replacement: 'colors.orange[5]'
  },
  colorGray: {
    value: darken(0.5125, '#fff'),
    replacement: 'colors.gray[4]'
  },
  colorGrayLight: {
    value: darken(0.13, '#fff'),
    replacement: 'colors.gray[7]'
  },
  colorGrayLightOnboarding: {
    value: '#F7F7F7',
    replacement: 'colors.gray[9]'
  },
  colorGrayDark: {
    value: darken(0.8, '#fff'),
    replacement: 'colors.gray[1]'
  },
  colorGrayBorder: {
    value: '#666',
    replacement: 'colors.gray[3]'
  },
  colorGreen: {
    value: '#9bca3e',
    replacement: 'colors.green[6]'
  },
  colorGreenLight: {
    value: lighten(colorOffsetLight, '#9bca3e'),
    replacement: 'colors.green[7]'
  },
  colorGreenDark: {
    value: darken(colorOffsetDark, '#9bca3e'),
    replacement: 'colors.green[5]'
  },
  colorRed: {
    value: '#bd2527',
    replacement: 'colors.red[3]'
  },
  colorRedLight: {
    value: lighten(colorOffsetLight, '#bd2527'),
    replacement: 'colors.red[4]'
  },
  colorRedDark: {
    value: darken(colorOffsetDark, '#bd2527'),
    replacement: 'colors.red[2]'
  },
  colorYellow: {
    value: '#ffd24d',
    replacement: 'colors.gold[6]'
  },
  colorYellowLight: {
    value: lighten(colorOffsetLight, '#ffd24d'),
    replacement: 'colors.gold[7]'
  },
  colorYellowDark: {
    value: darken(colorOffsetDark, '#ffd24d'),
    replacement: 'colors.gold[5]'
  },
  colorPink: {
    value: '#d91698',
    replacement: 'colors.violet[3]'
  },
  colorPinkLight: {
    value: lighten(colorOffsetLight, '#d91698'),
    replacement: 'colors.violet[4]'
  },
  colorPinkDark: {
    value: darken(colorOffsetDark, '#d91698'),
    replacement: 'colors.violet[2]'
  },
  colorPurple: {
    value: '#9545e5',
    replacement: 'colors.violet[3]'
  },
  colorPurpleLight: {
    value: lighten(colorOffsetLight, '#9545e5'),
    replacement: 'colors.violet[4]'
  },
  colorPurpleDark: {
    value: darken(colorOffsetDark, '#9545e5'),
    replacement: 'colors.violet[2]'
  },
  colorTwitterBlue: {
    value: '#00aced',
    replacement: 'colors.vendor.twitter'
  },
  colorFacebookBlue: {
    value: '#3b5998',
    replacement: 'colors.vendor.facebook'
  },
  colorMainBackground: {
    value: '#e6e6e6',
    replacement: 'colors.gray[8]'
  },
  colorOverlay: {
    value: 'rgba(0, 0, 0, .7)',
    replacement: 'rgba(0, 0, 0, .7)'
  },
  colorImportantInformation: {
    value: 'rgba(64,139,201,0.2)',
    replacement: 'rgba(64,139,201,0.2)'
  }
};
Object.keys(namedColors).forEach(function (color) {
  Object.defineProperty(theme.colors, color, {
    get: function get() {
      var matchingColor = namedColors[color];

      if (showWarnings) {
        console.warn("Usage of named colors (such as ".concat(color, ") is now deprecated. Try using ").concat(matchingColor.replacement, " instead."));
      }

      return matchingColor.value;
    },
    enumerable: true
  });
});
Object.keys(themeColors).forEach(function (color) {
  Object.defineProperty(theme, color, {
    get: function get() {
      // if (showWarnings) {
      // console.warn(
      //   `Usage of named colors (such as ${color}) is now deprecated. Try using ${themeColors[
      //     color
      //   ].replacement} instead.`
      // );
      return themeColors[color].value;
    },
    enumerable: true
  });
});
Object.keys(theme.colors).forEach(function (color) {
  Object.defineProperty(theme.color, color, {
    get: function get() {
      if (showWarnings) {
        console.warn("Usage of 'theme.color' is deprecated. Use 'theme.colors' instead.");
      }

      return theme.colors[color];
    },
    enumerable: true
  });
});
export default theme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-const/es/variables.js
// module id = 1288
// module chunks = 0